import { useSWRInfinite } from 'swr';
import app from '../base';

const LIMIT = 30;

const usePartnerLogs = ({ partnerId, filter }) => {
  const { data, error, size, setSize } = useSWRInfinite(
    (index) => {
      const params = new URLSearchParams();
      params.set('page', index + 1);
      params.set('limit', LIMIT);

      if (filter.period) params.set(`period`, filter.period?.value || filter.period);
      if (filter.dealers?.length) {
        filter.dealers.forEach((d) => params.append('hmsIds', d.hmsId));
      }
      if (filter.channel?.value) params.set('channel', filter.channel?.value);
      if (filter.status?.value) params.set('status', filter.status?.value);
      if (filter.vin) params.set('vin', filter.vin);

      if (partnerId) params.set('partnerId', partnerId);
      return `/lotlenz/partner-logs/requests?${params.toString()}`;
    },
    undefined,
    app.auth().currentUser.uid
  );

  const items = data ? data.flatMap((page) => page?.items || []) : [];
  const total = data?.[0]?.total ?? 0;
  const hasMore = items.length < total;

  return {
    items,
    total,
    hasMore,
    isLoading: !error && !data,
    isLoadingMore: size > 0 && data && typeof data[size - 1] === 'undefined',
    isError: error,
    size,
    setSize
  };
};

export default usePartnerLogs;
